import { PropsWithChildren } from 'react';
import { Navigate, useParams } from 'react-router';

import Loader from '@/components/Loader/Loader';
import { useStablecoinsAccess } from '@/hooks/useStablecoinsAccess';
import { isSupportedStablecoin } from '@/constants/stablecoins';
import { ERoutes } from '@/types/routes';

export const SupportedStablecoinRoute = ({ children }: PropsWithChildren) => {
  const { agioId } = useParams();
  const { isAccessResolved, isStablecoinAllowed } = useStablecoinsAccess();

  if (!isAccessResolved) return <Loader />;

  if (!!agioId && isSupportedStablecoin(agioId) && isStablecoinAllowed(agioId)) {
    return <>{children}</>;
  }

  return <Navigate to={ERoutes.STABLECOINS} replace />;
};
